export type QuestionType =
  | 'short_text'
  | 'long_text'
  | 'dropdown'
  | 'multiple_choice'
  | 'checkbox'
  | 'date'
  | 'number'
  | 'file_upload'
  | 'link'

export interface FixedField {
  id?: string
  fieldName: number
  isVisible: boolean
  isRequired: boolean
}

export interface QuestionOption {
  id: string
  text: string
  sortOrder?: number
}

export interface CustomQuestion {
  id?: string
  text: string
  description?: string
  type: QuestionType
  required: boolean
  hiddenFromEvaluators?: boolean
  expanded?: boolean
  sortOrder?: number
  options?: QuestionOption[]
}

export interface CustomSection {
  id?: string
  name: string
  eventChecked?: boolean
  meetingChecked?: boolean
  sortOrder?: number
  questions: CustomQuestion[]
  expanded: boolean
}

export interface RequestFormState {
  checkboxText: string
  checkboxRequired: boolean
  warningText: string
  fixedFields: FixedField[]
  sections: CustomSection[]
  fixedSectionExpanded: boolean
}

export const QUESTION_TYPE_LABELS: Record<QuestionType, string> = {
  short_text: 'Texto curto',
  long_text: 'Texto longo',
  dropdown: 'Lista suspensa',
  multiple_choice: 'Múltipla escolha',
  checkbox: 'Caixas de Seleção',
  date: 'Data',
  number: 'Número',
  file_upload: 'Upload de arquivo',
  link: 'Link',
}

export const QUESTION_TYPE_OPTIONS: Array<{ value: QuestionType; label: string }> = [
  { value: 'short_text', label: 'Texto curto' },
  { value: 'long_text', label: 'Texto longo' },
  { value: 'dropdown', label: 'Lista suspensa' },
  { value: 'multiple_choice', label: 'Múltipla escolha' },
  { value: 'checkbox', label: 'Caixas de Seleção' },
  { value: 'date', label: 'Data' },
  { value: 'number', label: 'Número' },
  { value: 'file_upload', label: 'Upload de arquivo' },
  { value: 'link', label: 'Link' },
]

export const OPTIONS_REQUIRED_TYPES: QuestionType[] = [
  'dropdown',
  'multiple_choice',
  'checkbox',
]

export const MAX_OPTIONS = 5
